<template lang="html">
  <div>
    <event-categories-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import EventCategoriesItem from './EventCategoriesItem'

export default {
  name: 'EventCategoriesList',
  components: {EventCategoriesItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Event Category',
      types: 'Event Categories',
      headers: [
        this.headerText('Event Category Name', 'name', true),
        this.headerText('Comments', 'notes', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'diningEventCategory'
    }
  },
  computed: {
  }
}
</script>
